export type BorderRadiusSize = Lowercase<keyof typeof BorderRadius>;

/**
 * List of radius sizes used by our borders.
 *
 * These values can be used in a CSS file as `var(--tfd-border-radius-<size>)`.
 *
 * @see https://corgi-x.tfd.engineering/system/borders
 */
export enum BorderRadius {
  /** No border radius. */
  None = 0,
  /** Extra-small border radius. */
  XS = 2,
  /** Small border radius. */
  SM = 4,
  /** Medium border radius. */
  MD = 6,
  /** Large border radius. */
  LG = 20,
  /** Very large border radius - meant to render a perfect semi-circlular border */
  Full = 9999,
}
